import * as React from 'react';
import { GlobalizationContext } from '../globalization/GlobalizationContext';
/**
 * @hidden
 */

export var useInternationalization = function useInternationalization() {
  return React.useContext(GlobalizationContext).intl;
};